import React from 'react';
import { cn } from '@/utils/cn';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'outline' | 'error' | 'business' | 'tech' | 'support';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'md',
  className
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';

  const variantClasses = {
    default: 'bg-muted/50 text-foreground',
    primary: 'bg-accent-blue text-foreground',
    secondary: 'bg-muted/50 text-foreground',
    success: 'bg-status-success text-foreground',
    warning: 'bg-status-warning text-foreground',
    danger: 'bg-status-error text-foreground',
    info: 'bg-status-info text-foreground',
    outline: 'bg-transparent border border-[var(--border)] text-[var(--text)]',
    error: 'bg-status-error text-foreground',
    business: 'bg-category-business-bg text-category-business-text',
    tech: 'bg-category-tech-bg text-category-tech-text',
    support: 'bg-category-support-bg text-category-support-text',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base'
  };

  return (
    <span 
      className={cn(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
export { Badge };